export default "__VITE_ASSET__CwCy1fOv__"